// Translation utility that loads i18n JSON files from /public/assets/i18n/
// Detects browser language automatically

let currentLang = 'en';
let translationsCache = {};

// Detect browser language
function detectBrowserLanguage() {
  const lang = (navigator.language || navigator.userLanguage || 'en').split('-')[0];
  return ['en', 'es'].includes(lang) ? lang : 'en';
}

// Load translations from JSON file
async function loadTranslations(lang) {
  try {
    const response = await fetch(`/assets/i18n/${lang}.json`);
    if (!response.ok) throw new Error(`HTTP ${response.status}`);
    const data = await response.json();
    translationsCache[lang] = data;
    return data;
  } catch (err) {
    console.warn(`Failed to load translations for "${lang}":`, err);
    // Fallback to empty object
    translationsCache[lang] = {};
    return {};
  }
}

// Initialize translations - call this once at app startup
export async function initTranslations() {
  const lang = detectBrowserLanguage();
  currentLang = lang;
  await loadTranslations(lang);
  // Also preload the other language for quick switching
  const otherLang = lang === 'en' ? 'es' : 'en';
  loadTranslations(otherLang);
  return lang;
}

export function setLanguage(lang) {
  if (['en', 'es'].includes(lang)) {
    currentLang = lang;
    // Load if not cached
    if (!translationsCache[lang]) {
      loadTranslations(lang);
    }
  }
}

export function getCurrentLanguage() {
  return currentLang;
}

export function translate(key) {
  if (translationsCache[currentLang] && translationsCache[currentLang][key]) {
    return translationsCache[currentLang][key];
  }
  return key;
}
